import { render, staticRenderFns } from "./inputLabel.vue?vue&type=template&id=4f82bcd3&"
import script from "./inputLabel.vue?vue&type=script&lang=js&"
export * from "./inputLabel.vue?vue&type=script&lang=js&"
import style0 from "./inputLabel.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports